

<template>
  <div style="background-color: #0A0F28">
    <div style="width: 100%; display: flex; align-items: center; justify-content: center">
      <text style="color: #02B4FF; font-size: 28px; margin-top: 24px">无人车投放量统计看板</text>
    </div>
    <search-bar  ref="searchRef" @search="doSearch"/>
    <div class="card-container">
      <!-- 1. 完全不传参数 (使用全部默认值: 默认图标, 默认标题, 默认颜色, 默认显示--) -->
      <DashboardCard
        title="波次总量"
        :value="transferData(cardData.waveTotalNum)"
        borderColor="#00d8ff"
      />

      <!-- 2. 还原图1：已投放无人车总量 (蓝色) -->
      <DashboardCard
        title="波次总时长(小时)"
        :value="transferData(cardData.waveDurationHours)"
        borderColor="#00d8ff"
      >
        <!-- 这里省略 icon 插槽，因为组件自带的默认图标就是车 -->
      </DashboardCard>

      <!-- 3. 还原图3：投递中数量 (绿色) -->
      <DashboardCard
        title="满载波次占比(%)"
        :value="transferData(cardData.fullLoadRate)+'%'"
        borderColor="#00e676"
      >
        <template #icon>
          <!-- 传入自定义的 SVG 图标 (纸飞机) -->
          <svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" stroke-width="2" fill="none">
            <line x1="22" y1="2" x2="11" y2="13"></line>
            <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
          </svg>
        </template>
      </DashboardCard>

      <!-- 4. 还原图4：充电/待命数量 (黄色) -->
      <DashboardCard
        title="格口使用率(%)"
        :value="transferData(cardData.gridUseRate)+'%'"
        borderColor="#ffc107"
      >
        <template #icon>
          <!-- 传入自定义的电池图标 -->
          <svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" stroke-width="2" fill="none">
            <rect x="2" y="7" width="16" height="10" rx="2" ry="2"></rect>
            <line x1="22" y1="11" x2="22" y2="13"></line>
          </svg>
        </template>
      </DashboardCard>
    </div>
    <div style="width: 100%; display: flex; flex-direction: row">
      <div style="flex: 1; padding: 20px">
       <WaveTrendLineChart ref="waveTrendRef"/>
      </div>
      <div style="flex: 1; padding: 20px">
        <WaybillTrendLineChart ref="waybillTrendRef"/>
      </div>
    </div>
    <div style="width: 100%; display: flex; flex-direction: row">
      <div style="flex: 1; padding: 20px">
        <WaveAverageLineChart ref="waveAverageRef"/>
      </div>
      <div style="flex: 1; padding: 20px">
        <BoxAverageLineChart ref="boxAverageRef"/>
      </div>
    </div>
    <div style="width: 100%; display: flex; flex-direction: row">
      <div style="flex: 1; padding: 20px">
        <UsageRateLineChart ref="usageRateRef"/>
      </div>
      <div style="flex: 1; padding: 20px">
        <DeliverySpeedLineChart ref="deliverySpeedRef"/>
      </div>
    </div>

  </div>
</template>

<script setup>

import DashboardCard from '@/components/tdl/data/package/DashboardCard.vue'
import SearchBar from '@/components/tdl/data/package/SearchBar.vue'
import WaveAverageLineChart from '@/components/tdl/data/efficiency/WaveAverageLineChart.vue'
import { onMounted, ref, shallowRef } from 'vue'

import WaveTrendLineChart from '@/components/tdl/data/efficiency/WaveTrendLineChart.vue'
import WaybillTrendLineChart from '@/components/tdl/data/efficiency/WaybillTrendLineChart.vue'
import BoxAverageLineChart from '@/components/tdl/data/efficiency/BoxAverageLineChart.vue'
import UsageRateLineChart from '@/components/tdl/data/efficiency/UsageRateLineChart.vue'
import DeliverySpeedLineChart from '@/components/tdl/data/efficiency/DeliverySpeedLineChart.vue'
import { useHostAppInstance } from '@zto/zpage'
const searchRef = ref()
const waveTrendRef = shallowRef()
const waybillTrendRef = shallowRef()
const waveAverageRef = shallowRef()
const boxAverageRef = shallowRef()
const usageRateRef = shallowRef()
const deliverySpeedRef = shallowRef()
const app = useHostAppInstance()
const cardData = ref({})

const doSearch = (params) => {
  console.log('====效率分析搜索条件：', JSON.stringify(params))
  queryCardData(params)
  waveTrendRef.value.queryLineData(params)
  waybillTrendRef.value.queryLineData(params)
  waveAverageRef.value.queryLineData(params)
  boxAverageRef.value.queryLineData(params)
  usageRateRef.value.queryLineData(params)
  deliverySpeedRef.value.queryLineData(params)
}
const queryCardData = async (params) => {
  console.log('====获取卡片数据')
  try {
    const resp = await app.request({
      api: '/sys/admin/statistics/wave-statistics/wave/summary',
      params: params
    })
    // console.log('====doSearch resp:', JSON.stringify(resp))
    if (resp) {
      cardData.value = resp
    }
  } catch (e) {

  }
}
const transferData = (num) => {
  if (typeof num === 'number') {
    return num
  }
  return '--'
}
onMounted(() => {
  waveTrendRef.value.initChart()
  waybillTrendRef.value.initChart()
  waveAverageRef.value.initChart()
  boxAverageRef.value.initChart()
  usageRateRef.value.initChart()
  deliverySpeedRef.value.initChart()
  searchRef.value.handleShortcut(7)
  const params = searchRef.value.getSearchParams()
  doSearch(params)

});
</script>

<style scoped>
.card-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  background-color: #0a0f28; /* 页面深色底色 */
  padding: 20px;
}
</style>
